import React, { useState, useEffect, useMemo } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Col, Row, Form, Select, Input } from "antd";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import styled from "styled-components";
import COLORS from "../../common/Colors";
import TabsList from "../../molecules/TabsList";
import ClientInformation from "./ClientInformation";
import GeneralInformation from "./GeneralInformation";
import EMSRecord from "./EMSRecord";
import COICheckProcess from "./COICheckProcess";
import ClientOnboarding from "./ClientOnboarding";
import { useScrollFetch } from "hooks/useScrollFetch";
import queryKeys from "common/queryKey";

const StyledPage = styled.div`
  padding: 20px;
  background: #fff;
  border-radius: 12px;

  .breadcrumb-link {
    font-size: 16px;
    cursor: pointer;
    color: #444;
    display: inline-flex;
    align-items: center;
  }

  .client-title {
    font-size: 22px;
    font-weight: 700;
    margin: 8px 0 16px 0;
  }

  .client-info-block p {
    margin: 0;
    font-size: 14px;
  }

  .label {
    color: #666;
  }

  .value {
    font-weight: 600;
  }

  .vertical-divider {
    width: 1px;
    background: #ddd;
    height: 40px;
  }
`;

const ClientDetails = () => {
  // const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const clientId = window.location.pathname.split("/").pop();

  const { getClient } = queryKeys;

  const {
    data: clientDetailsPages,
    isLoading: isEditLoading,
  } = useScrollFetch(
    clientId ? getClient(clientId).key : null,
    clientId
      ? { endPoint: getClient(clientId).url }
      : null,
    {
      getNextPageParam: () => null,
    }
  );


  const clientData =
    clientDetailsPages?.pages?.[0]?.response?.client ?? null;


  const extraData = location.state ? location.state.extraData : null;
  // const filteredData = extraData?.filter((item) => item?.bdo_id == id);
  const filteredData = []

  const [tabId, setTabId] = useState("Client Information");



  const clientTabs = useMemo(
    () => [
      {
        id: "Client Information",
        label: "Client Information",
        component: <ClientInformation filteredData={clientData} />,
      },
      {
        id: "General Details",
        label: "General Details",
        component: <GeneralInformation filteredData={clientData} />,
      },
      {
        id: "Client OnBoarding",
        label: "Client OnBoarding",
        component: <ClientOnboarding data={clientData} />,
      },
      {
        id: "COI Check Process",
        label: "COI Check Process",
        component: <COICheckProcess data={clientData} />,
      },
      {
        id: "EMS Records",
        label: "EMS Records",
        component: <EMSRecord filteredData={clientData} />,
      },
      // {
      //   id: "Documents",
      //   label: "EMS Records",
      //   component: <EMSRecord filteredData={clientData} />,
      // }
    ],
    [clientData]
  );

  return (
    <StyledPage>
      {/* ⭐ Breadcrumb */}
      <div
        className="breadcrumb-link"
        onClick={() => history.push(`/client`)}
      >
        Client <ArrowForwardIosIcon fontSize="small" />
      </div>

      {/* ⭐ Client Title */}
      <div className="client-title">{clientData?.name ?? "-"}</div>

      {/* ⭐ Client Header Info */}
      <Row gutter={24} align="middle" className="client-info-block" style={{ marginBottom: 20 }}>
        <Col>
          <p className="value">{clientData?.bdo_id ?? "-"}</p>
          <p className="label">Client ID</p>
        </Col>

        <Col>
          <div className="vertical-divider" />
        </Col>

        <Col>
          <p className="value">
            {clientData?.["statecode@OData.Community.Display.V1.FormattedValue"] ?? "-"}
          </p>
          <p className="label">Status Reason</p>
        </Col>

        <Col>
          <div className="vertical-divider" />
        </Col>

        <Col>
          <p className="value">
            {clientData?.["bdo_status@OData.Community.Display.V1.FormattedValue"] ?? "-"}
          </p>
          <p className="label">COB FORM Status</p>
        </Col>

        <Col>
          <div className="vertical-divider" />
        </Col>

        <Col>
          <p className="value" style={{ color: "#1677ff" }}>
            {clientData?.["_ownerid_value@OData.Community.Display.V1.FormattedValue"] ?? "-"}
          </p>
          <p className="label">Owner</p>
        </Col>
      </Row>

      {/* ⭐ Tabs */}
      <TabsList items={clientTabs} handleTabSelect={setTabId} tabId={tabId} />
    </StyledPage>
  );
};

export default ClientDetails;
